import { render, staticRenderFns } from "./industrySecondPage.vue?vue&type=template&id=13b919c7&scoped=true&"
import script from "./industrySecondPage.vue?vue&type=script&lang=js&"
export * from "./industrySecondPage.vue?vue&type=script&lang=js&"
import style0 from "./industrySecondPage.vue?vue&type=style&index=0&id=13b919c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b919c7",
  null
  
)

export default component.exports